import { useRecordContext, useTranslate } from "react-admin";

import { OrganizationRecordWithLocations } from "../types/organization";
import { InfoFieldData, InfoPanel } from "./InfoPanel";

export const OrganizationInfoPanel = () => {
  const record = useRecordContext<OrganizationRecordWithLocations>();
  const translate = useTranslate();

  if (!record) return null;

  const sections: InfoFieldData[][] = [
    [
      { label: translate("organizationName"), value: record.name },
      { label: translate("externalId"), value: record.externalId },
    ],
    [
      { label: translate("street"), value: record.street },
      { label: translate("postalCode"), value: record.postalCode },
      { label: translate("city"), value: record.city },
    ],
    [{ label: translate("internalId"), value: record.id }],
    [{ label: translate("additionalInfo"), value: record.additionalInfo }],
  ];

  return <InfoPanel sections={sections} />;
};
